import { isEmailNotConfirmedError } from '@/modules/base/util/errors'
import openConfirmEmailModal from '@/modules/_helpers/openConfirmEmailModal'

/**
 * DO-13065: the API refuses to send mail for an unverified address with
 * `403 { meta: { email: [{ code: 'NOT_CONFIRMED' }] } }`.
 *
 * The request layer (base/util/request.js) already turns that status into the matching toast for
 * every caller. Send dialogs call this from their error handler to additionally offer the DOI modal
 * and to skip their own generic "could not send" toast.
 *
 * @returns true when the error was the NOT_CONFIRMED refusal and has been handled
 */
export const handleEmailNotConfirmedError = (error: unknown): boolean => {
  if (!isEmailNotConfirmedError(error)) return false
  openConfirmEmailModal()
  return true
}

export default handleEmailNotConfirmedError
